import { render, staticRenderFns } from "./query-record.vue?vue&type=template&id=ad8abb48&scoped=true&"
import script from "./query-record.vue?vue&type=script&lang=ts&"
export * from "./query-record.vue?vue&type=script&lang=ts&"
import style0 from "./query-record.vue?vue&type=style&index=0&id=ad8abb48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8abb48",
  null
  
)

export default component.exports